import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

export const RouteRestoreGuard: CanActivateFn = () => {
  const router = inject(Router);

  // Check if we have a saved route to restore
  const savedRoute = sessionStorage.getItem("auth_redirect");

  if (savedRoute && savedRoute !== "/" && savedRoute !== "") {
    sessionStorage.removeItem("auth_redirect");
    // Navigate to the saved route
    router.navigateByUrl(savedRoute);
    return false; // Prevent navigation to root
  }

  return true; // Allow navigation to root
};
